import { Popover } from '@mui/material';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import AvatarIcon from '../../../assets/svg/AvatarIcon';
import CrossIcon from '../../../assets/svg/CrossIcon';
import GlassIcon from '../../../assets/svg/GlassIcon';

export const TeamFilter = ({
  callerId,
  onChangeCallerId,
  managerTeam,
  isManagerTeamLoading,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchValue, setSearchValue] = useState('');

  const onChangeSearchValue = e => {
    const nextSearchValue = e.target.value;
    setSearchValue(nextSearchValue);
  };

  const resetSearchValue = () => {
    setSearchValue('');
  };

  const onChange = callerId => {
    onChangeCallerId(prev => ({ ...prev, callerId }));
    onClosePopover();
  };

  const reset = () => {
    onChangeCallerId(prev => ({ ...prev, callerId: null }));
  };

  const onOpenPopover = e => {
    if (e.target.localName !== 'button') return;
    setSearchValue('');
    setAnchorEl(e.currentTarget);
  };

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const filteredManagerTeam = managerTeam.filter(v => {
    const searchValueToLowerCase = searchValue.toLowerCase();
    const nameToLowerCase = v.name.toLowerCase();
    return nameToLowerCase.includes(searchValueToLowerCase);
  });
  const open = Boolean(anchorEl);
  const hasCallerId = !!callerId;
  const hasManagerTeam = filteredManagerTeam.length > 0;
  const hasSearchValue = searchValue.length > 0;

  return (
    <>
      <button
        className={twMerge(
          'flex items-center gap-2 rounded-full py-[11px] px-6 text-brand-900 border border-brand-900 font-medium text-[16px]/[24px] focus-visible:outline-none',
          hasCallerId && 'bg-brand-900 text-white !pl-6 !pr-5',
        )}
        onClick={onOpenPopover}
        disabled={isManagerTeamLoading}
      >
        {hasCallerId ? callerId : 'Team'}
        {hasCallerId && (
          <div onClick={reset}>
            <CrossIcon className="w-4 h-4 text-white" />
          </div>
        )}
      </button>
      <Popover
        open={open}
        slotProps={{
          paper: {
            className:
              '!rounded-xl mt-2 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-[260px]',
          },
        }}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className="p-1 overflow-hidden">
          <div className="relative">
            <GlassIcon className="w-5 h-5 text-brand-500 absolute left-3.5 top-2.5" />
            <input
              value={searchValue}
              onChange={onChangeSearchValue}
              placeholder="Search"
              className="w-full py-2 pl-11 pr-[38px] text-[16px]/[24px] text-base-1000 border-none placeholder:text-base-800 focus:outline-none"
            />
            {hasSearchValue && (
              <div
                onClick={resetSearchValue}
                className="absolute right-3 top-3 cursor-pointer"
              >
                <CrossIcon className="w-4 h-4 text-base-1000" />
              </div>
            )}
          </div>
          {hasManagerTeam ? (
            <div className="flex flex-col gap-1 max-h-[268px] overflow-auto">
              {filteredManagerTeam.map(({ name, FullName }) => {
                const isSelected = name === callerId;

                return (
                  <button
                    key={name}
                    className={twMerge(
                      'flex items-center gap-2 py-2 px-3 rounded-lg shrink-0 hover:bg-brand-200',
                      isSelected && 'bg-brand-100',
                    )}
                    onClick={() => {
                      onChange(name);
                    }}
                  >
                    <AvatarIcon className="w-6 h-6 shrink-0" />
                    <span className="text-[16px]/[24px] text-base-1000 truncate">
                      {FullName}
                    </span>
                  </button>
                );
              })}
            </div>
          ) : (
            <div className="flex py-2 px-3">
              <span className="text-[16px]/[24px] text-base-1000 text-center w-full">
                Not Found
              </span>
            </div>
          )}
        </div>
      </Popover>
    </>
  );
};
